import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
// const baseUrl = 'http://192.168.1.5:3021'

// const baseUrl = 'https://gec-api.gecacademy.cn/souapi/'
// const baseUrl = 'http://192.168.0.5:10066/'
let baseUrl = ''
const origin = window.location.origin
if (process.env.NODE_ENV === 'development') {
  baseUrl = process.env.VUE_APP_BASE_API
} else {
  if (origin.indexOf('-testserver') > -1) {
    baseUrl = process.env.VUE_APP_BASE_API_DEV
  } else {
    baseUrl = process.env.VUE_APP_BASE_API_MASTER
  }
}

const service = axios.create({ baseURL: baseUrl, timeout: 60000, withCredentials: true })
service.interceptors.request.use(
  config => { return config },
  error => {
    console.log('error' + error)
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.error.returnCode !== 0) {
      const errorCode = res.error.returnCode
      if (errorCode === 10000) { router.push('/login') }
      Toast({ message: res.error.returnMessage || 'Error', type: 'fail', duration: 5 * 1000 })
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Toast({ message: error.message, type: 'fail', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service
